var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"view-ui-button-getstarted button-primary size-medium",on:{"click":function($event){return _vm.$emit('continue')}}},[_vm._v(" Get Started ")])
}
var staticRenderFns = []

export { render, staticRenderFns }